import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import Select from 'react-select';

import ErrorMessage from '../Errors/ErrorMessage';

const MultiSelect = ({
  options = [],
  name,
  title,
  getOptionLabel,
  getOptionValue,
  optionValue = 'id',
  serverError,
  isLoading,
  className = '',
  defaultValue = [],
  closeMenuOnSelect = false,
  onChange,
}) => {
  const { errors, setFieldValue, values } = useFormikContext();
  return (
    <div className='form-group'>
      <label className='f-13 text-dark text-left d-flex flex-row justify-content-start'>
        {title}
      </label>
      <Select
        defaultValue={defaultValue}
        isMulti
        options={options}
        onChange={(value) => {
          setFieldValue(
            name,
            value.map((v) => v?.[optionValue]),
            true,
          );
          if (onChange) {
            onChange(value);
          }
        }}
        noOptionsMessage={() => `${title} جهت انتخاب یافت نشد!`}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        closeMenuOnSelect={closeMenuOnSelect}
        className={className}
        classNamePrefix='text-left justify-content-start'
        placeholder='انتخاب کنید...'
        isLoading={isLoading}
      />
      <ErrorMessage error={errors[name] ? errors[name] : serverError} />
    </div>
  );
};

MultiSelect.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  options: PropTypes.array.isRequired,
  getOptionLabel: PropTypes.any,
  getOptionValue: PropTypes.any,
  multiLabel: PropTypes.bool,
  serverError: PropTypes.any,
  defaultValue: PropTypes.array,
  isLoading: PropTypes.bool,
  closeMenuOnSelect: PropTypes.bool,
  onChange: PropTypes.func,
};

export default MultiSelect;
